export default {
  computed: {
    itemsQuickFilters() {
      return {
        title: 'Items',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-reference-code',
                  label: this.$gettext('Reference Code'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['reference_code', 'ct', val.trim()]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-enabled',
                  label: this.$gettext('Item Status'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Enabled'),
                      value: 1
                    },
                    {
                      text: this.$gettext('Disabled'),
                      value: false
                    }
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val === 1) {
                      return [['active', 'eq', 1]]
                    } else if (val === false) {
                      return [['active', 'eq', false]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-description',
                  label: this.$gettext('Description'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['description', 'ct', val.trim()]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'item-last-position-updated-at',
                  label: this.$gettext('Last Position Updated At Date Range'),
                  type: 'daterange',
                  opens: 'left',
                  showIf: () => this.ecosystemModules.items.geolocalizableBy && this.ecosystemModules.items.geolocalizableBy !== null,
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  ranges: {
                    [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
                    [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
                    [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()],
                    [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
                    [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
                    [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['last_position_updated_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    itemsShippingHistoryQuickFilters() {
      return {
        title: 'Items Shipping History',
        filters: {
          columns: [
            {
              class: 'col-12',
              filters: [
                {
                  name: 'item-shippings-status',
                  label: this.$gettext('Statuses'),
                  type: 'checkbox-group',
                  options: this.$appConfig.validStates,
                  value: [],
                  stacked: false,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['status', 'in', val]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-courier',
                  label: this.$gettext('Courier'),
                  type: 'user-autocomplete',
                  restrictToRoles: ['courier'],
                  placeholder: this.$gettext('Courier name or email'),
                  value: [],
                  props: {
                    endpoint: 'companies/users'
                  },
                  callback: (val) => {
                    if (val.length > 0) {
                      const couriers = val.map(function (item) {
                        return item.id
                      })
                      return [['courier_id', 'in', couriers]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-created-at',
                  label: this.$gettext('Created At Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['created_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-sm-4 col-lg-4',
              filters: [
                {
                  name: 'item-shippings-updated-at',
                  label: this.$gettext('Updated At Date Range'),
                  type: 'daterange',
                  opens: 'left',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: false
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['updated_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    itemsTrackingHistoryEventsQuickFilters() {
      return {
        title: 'Items Tracking History Events',
        filters: {
          columns: [
            {
              class: 'col-12',
              filters: [
                {
                  name: 'item-shippings-created-at',
                  label: this.$gettext('Event Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  locale: {
                    format: this.$gettext('mm/dd/yyyy')
                  },
                  value: {
                    startDate: this.moment().subtract(6, 'days').toDate(),
                    endDate: this.moment().toDate(),
                    dateRangeActive: true
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [['created_at', 'bt', range]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
